  // Centralized API base + fetch helper

  const API_BASE = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, ""); // strip trailing slash

  export function apiUrl(path) {
    if (!path.startsWith("/")) path = "/" + path;
    return API_BASE ? `${API_BASE}${path}` : path; // same-origin if not set
  }

  // Fetch wrapper: sends cookies, parses JSON/text, throws on !ok
  export async function apiFetch(
    path,
    { method = "GET", headers = {}, body, cache = "no-store", bust = false } = {}
  ) {
    const url = apiUrl(path) + (bust ? (path.includes("?") ? "&" : "?") + "t=" + Date.now() : "");
    const r = await fetch(url, {
      method,
      credentials: "include",
      headers,
      cache,
      body,
    });

    // Prefer JSON, fallback to text
    const ct = r.headers.get("content-type") || "";
    let data;
    if (ct.includes("application/json")) data = await r.json().catch(() => ({}));
    else {
      const t = await r.text().catch(() => "");
      data = t ? { message: t } : {};
    }

    if (!r.ok) {
      const msg = data?.error || data?.message || `${r.status} ${r.statusText}` || "request_failed";
      const err = new Error(msg);
      err.status = r.status;
      err.payload = data;
      throw err;
    }
    return data;
  }
